import React from 'react';
import CustomModal from '../../UI/Modal/CustomModal';
import './ProcessingSpinner.css';

const ProcessingSpinner = (props) => (
    <div className="Processing-Loader-Container">
        <div className=  "Processing-Loader" >
            <CustomModal 
                showModel = {true}
                Status = {props.Status}
                BusinessPartnerCode = {props.BusinessPartnerCode}
                RevenueDate = {props.RevenueDate}
                ErrorMessage = {props.ErrorMessage}
            />
        </div>
    </div>
);

export default ProcessingSpinner;